import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';

class FilterFooter extends Component {
  render() {
    const {
      onClearFilters, onToggleAdvancedFilters, showAdvancedFilters, showObjectiveFilters
    } = this.props;
    return (
      <Row className="filter-footer">
        <Col lg={4}>
          {'\u00a0'}
        </Col>
        <Col lg={4} className="advanced-filter">
          {showObjectiveFilters && (
            <a onClick={onToggleAdvancedFilters}>
              {showAdvancedFilters ? 'hide' : 'show'} advanced filters
            </a>
          )}
        </Col>
        <Col lg={4}>
          <a className="pull-right" onClick={onClearFilters}>Clear filters x</a>
        </Col>
      </Row>
    );
  }
}

export default FilterFooter;



// WEBPACK FOOTER //
// ./src/components/product-page/filters/filter-footer.jsx